import Countdown from "react-countdown"

function CountdownCard(props) {
 
  const endTime = 1790669386000;

    return ( 
       <>
       <Countdown
            date={endTime ? endTime : 1760826920000}
            renderer={props => (
                <>
                <style>
        {`
          .timer-box {
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.2) 100%);
            border: 2px solid rgba(255, 255, 255, 0.2);
            border-radius: 12px;
            padding: 10px;
            text-align: center;
            min-width: 100px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            transition: transform 0.2s ease-in-out;
          }

          .timer-box:hover {
            transform: translateY(-5px);
          }

          .tab-val {
            font-size: 2rem;
            font-weight: bold;
            color: #fff;
          }

          .tab-unit {
            font-size: 1rem;
            text-transform: uppercase;
            color: rgba(255, 255, 255, 0.8);
          }

          
        `}
      </style>
<div className="counterdown-content">
  <div className="count-down titled circled text-center">
    <div className="simple_timer syotimer timer">
      <div className="timer-head-block" />
      <br/>
      <div className="timer-body-block">
        <div className="row justify-content-center g-3">
          <div className="col-6 col-md-3">
            <div className="timer-box">
              <div className="tab-val">{props.days}</div>
              <div className="tab-metr tab-unit">Days</div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="timer-box">
              <div className="tab-val">{props.hours}</div>
              <div className="tab-metr tab-unit">Hours</div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="timer-box">
              <div className="tab-val">{props.minutes}</div>
              <div className="tab-metr tab-unit">Minutes</div>
            </div>
          </div>
          <div className="col-6 col-md-3">
            <div className="timer-box">
              <div className="tab-val">{props.seconds}</div>
              <div className="tab-metr tab-unit">Seconds</div>
            </div>
          </div>
        </div>
      </div>
      <br/>
      <div className="timer-foot-block" />
    </div>
  </div>
</div>
                </>
             )}
        /> 
    
     </> 
 ); 

}

export default CountdownCard;